import { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import {
    countryList, getMyPlan, updateCurrentplan, getAssignPlan, getBalanceAmount, assignBranch, assignservice, assignTeam, CancelPlanStripe,
    CancelPlan, checkRefundPrice, checkMendatory, updatePlanDate, planHistory
} from '../../../Context/api';
import axios from 'axios';
import { commonMessage, statusCodes } from '../../../Constants/generalConfig';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';


const UseAssignPlan = () => {
    const navigate = useNavigate()
    const adminData = JSON.parse(localStorage.getItem('adminData'));
    const [spinner, setSpinner] = useState(false)
    const [countryData, setCountryData] = useState([])
    const [teamData, setTeamData] = useState([])
    const [serviceData] = useState([])
    const [branchData, setBranchData] = useState([])
    const [pendingBalance, setPendingBalance] = useState('')
    const [currentPlanData, setCurrentPlanData] = useState([])
    const [assignedPlanData, setAssignedPlanData] = useState([])
    const [tab, setTab] = useState(1)
    const [cancelPrice, setCancelPrice] = useState('')
    const [show, setShow] = useState(false)
    const [planHistoryData, setPlanHistoryData] = useState([])
    const [mandatory, setMandatory] = useState(false)
    const [planType, setPlanType] = useState('CUSTOM')
    const [editEndDate, setEditEndDate] = useState({
        open: false,
        endDate: '',
        reason: ''
    });
    const [count, setCount] = useState('')
    const [page, setPage] = useState(1)
    const PER_PAGE = 10
    const { id } = useParams()
    useEffect(() => {
        countryListData()
        currentPlan()
        assignPlanGet()
        checkMendatoryBranch()

        team()
        service()
        branch()
    }, [])
    console.log(count, 'count')
    useEffect(() => {
        getPlanHistory()
    }, [page])
    const countryListData = () => {
        const data = {
            id: adminData.userId,
            isDeleted: true,
            isActive: true,
            searchText: '',
            page: 1,
            count: 100
        }

        axios.post(countryList(), { ...data }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setCountryData(resp.data.data)

            }
            else {
                setCountryData([])
                setSpinner(false)
            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
                setSpinner(false)
            })
    }
    const balance = () => {
        axios.post(getBalanceAmount(), { userId: id }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setPendingBalance(resp.data.totalBalanceAmount)

            }
            else {
                // setPendingBalance([])
                setSpinner(false)
            }
        })
    }
    const team = () => {
        axios.post(assignTeam(), { userId: id }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setTeamData(resp.data.teamData)

            }
            else {
                setTeamData([])
                setSpinner(false)
            }
        })
    }
    const branch = () => {
        axios.post(assignBranch(), { userId: id }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setBranchData(resp.data.branchData)

            }
            else {
                setBranchData([])
                setSpinner(false)
            }
        })
    }
    const service = () => {
        axios.post(assignservice(), { providerId: id }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                // setServiceData(resp.data.serviceData)
                if (serviceData.length === 0) {
                    resp.data.data.map((item) => {
                        return item.servicedetails.map((value) => {
                            return serviceData.push({ categoryName: item.categoryName, serviceName: value.serviceName, serviceId: value.serviceId })
                        })
                    })
                }
                // console.log(resp.data.serviceData,'resp.data.serviceData')

            }
            else {
                // setServiceData([])
                setSpinner(false)
            }
        })
    }
    const currentPlan = () => {
        axios.post(getMyPlan(), { providerId: id }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setCurrentPlanData(resp.data.data)
                resp.data.data.addons?.map((item) => {
                    if (item.constName === 'CHAT') {
                        addOnsUpdate.setFieldValue('addOns.chat', item.keyValue)
                        addOnsUpdate.setFieldValue('addOnsInput.chat', item.price)
                    }
                    if (item.constName === 'STAFFLOGIN') {
                        addOnsUpdate.setFieldValue('addOns.staffLogin', item.keyValue)
                        addOnsUpdate.setFieldValue('addOnsInput.staffLogin', item.price)
                    }
                    if (item.constName === 'EMAILREMAINDER') {
                        addOnsUpdate.setFieldValue('addOns.emailRemainder', item.keyValue)
                        addOnsUpdate.setFieldValue('addOnsInput.emailRemainder', item.price)
                    }
                    if (item.constName === 'INSIGHT') {
                        addOnsUpdate.setFieldValue('addOns.insight', item.keyValue)
                        addOnsUpdate.setFieldValue('addOnsInput.insight', item.price)
                    }
                    if (item.constName === 'REWARDS') {
                        addOnsUpdate.setFieldValue('addOns.rewards', item.keyValue)
                        addOnsUpdate.setFieldValue('addOnsInput.rewards', item.price)
                    }
                })
            }
            else {
                setSpinner(false)
            }
        })
    }
    const assignPlanGet = () => {
        axios.post(getAssignPlan(), { providerId: id }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setAssignedPlanData(resp.data.data)
                let data = resp?.data?.data?.features?.map((item) => (
                    { constName: item?.constName, keyName: item?.keyName, keyValue: item?.keyValue }
                ))
                // assignedPlan.setFieldValue('features', data)
                // assignedPlan.setFieldValue('startDate', resp.data.data.startDate)
                // assignedPlan.setFieldValue('endDate', resp.data.data.endDate)
                // assignedPlan.setFieldValue('validity', resp.data.data.validity)
                // assignedPlan.setFieldValue('finalPrice', resp.data.data.finalPrice)
                // assignedPlan.setFieldValue('discountType', resp.data.data.discountType)
                // assignedPlan.setFieldValue('discountValue', resp.data.data.discountValue)
                // assignedPlan.setFieldValue('planPrice', resp.data.data.planPrice)
                // resp.data.data.addons?.map((item) => {
                //     if (item.constName === 'CHAT') {
                //         assignedPlan.setFieldValue('addOns.chat', item.keyValue)
                //         assignedPlan.setFieldValue('addOnsInput.chat', item.price)
                //     }
                //     if (item.constName === 'STAFFLOGIN') {
                //         assignedPlan.setFieldValue('addOns.staffLogin', item.keyValue)
                //         assignedPlan.setFieldValue('addOnsInput.staffLogin', item.price)
                //     }
                //     if (item.constName === 'EMAILREMAINDER') {
                //         assignedPlan.setFieldValue('addOns.emailRemainder', item.keyValue)
                //         assignedPlan.setFieldValue('addOnsInput.emailRemainder', item.price)
                //     }
                //     if (item.constName === 'INSIGHT') {
                //         assignedPlan.setFieldValue('addOns.insight', item.keyValue)
                //         assignedPlan.setFieldValue('addOnsInput.insight', item.price)
                //     }

                // })
            }
            else {
                setSpinner(false)
            }
        })
    }
    // const assignedPlan = useFormik({
    //     initialValues: {
    //         features: [
    //             {
    //                 keyName: "",
    //                 keyValue: "",
    //                 constName: ""
    //             }
    //         ],
    //         validity: '',
    //         planPrice: '',
    //         discountType: '',
    //         discountValue: '',
    //         finalPrice: '',
    //         addOns: { chat: false, multipleServiceBooking: false, staffLogin: false, emailRemainder: false, ticketSupport: false, insight: false },
    //         addOnsInput: { chat: 0, multipleServiceBooking: 0, staffLogin: 0, emailRemainder: 0, ticketSupport: 0, insight: 0 },
    //         country: ''
    //     },
    //     onSubmit: (values) => {
    //         const data = {
    //             userId: id,
    //             addons: [
    //                 {
    //                     keyName: "chat",
    //                     keyValue: values.addOns.chat,
    //                     constName: "CHAT",
    //                     price: values.addOnsInput.chat
    //                 },
    //                 {
    //                     keyName: "insight",
    //                     keyValue: values.addOns.insight,
    //                     constName: "INSIGHT",
    //                     price: values.addOnsInput.insight
    //                 },
    //                 {
    //                     keyName: "staff login",
    //                     keyValue: values.addOns.staffLogin,
    //                     constName: "STAFFLOGIN",
    //                     price: values.addOnsInput.staffLogin
    //                 },
    //                 {
    //                     keyName: "email Remainder",
    //                     keyValue: values.addOns.emailRemainder,
    //                     constName: "EMAILREMAINDER",
    //                     price: values.addOnsInput.emailRemainder
    //                 }

    //             ],
    //         }
    //         // setSpinner(true)
    //         // axios.post(updateCurrentplan(), data).then((resp) => {
    //         //     if (resp.data.code === statusCodes.ok) {
    //         //         toast.success(resp.data.message)
    //         //         setSpinner(false)
    //         //     }
    //         //     else {
    //         //         toast.error(resp.data.message)
    //         //         setSpinner(false)
    //         //     }
    //         // })
    //         //     .catch(() => {
    //         //         toast.error(commonMessage.networkError)
    //         //         setSpinner(false)
    //         //     })
    //     },
    // });
    const checkRefund = () => {
        setSpinner(true)
        axios.post(checkRefundPrice(), { userId: id }, { headers: { Authorization: `Bearer ${adminData?.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setCancelPrice(resp.data.data)
                setSpinner(false)
            }
            else {
                setSpinner(false)
                setCancelPrice('')
            }
        })
            .catch(() => {
                setSpinner(false)
                toast.error(commonMessage.networkError)
            })
    }
    const cancelPlans = () => {
        setSpinner(true)
        axios.post(currentPlanData?.paymentMode == 'STRIPE' ? CancelPlanStripe() : CancelPlan(), { userId: id }, { headers: { Authorization: `Bearer ${adminData?.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                toast.success(resp.data.message)
                setSpinner(false)
                setShow(false)
                currentPlan()
            }

            else {
                setSpinner(false)
            }
        })
            .catch(() => {
                setSpinner(false)
                toast.error(commonMessage.networkError)
            })
    }
    const addOnsUpdate = useFormik({
        initialValues: {
            addOns: { chat: false, staffLogin: false, emailRemainder: false, insight: false, rewards: false },
            addOnsInput: { chat: 0, staffLogin: 0, emailRemainder: 0, insight: 0, rewards: 0 }
        },
        onSubmit: (values) => {
            const data = {
                userId: id,
                addons: [
                    {
                        keyName: "chat",
                        keyValue: values.addOns.chat,
                        constName: "CHAT",
                        price: values.addOnsInput.chat
                    },
                    {
                        keyName: "insight",
                        keyValue: values.addOns.insight,
                        constName: "INSIGHT",
                        price: values.addOnsInput.insight
                    },
                    {
                        keyName: "staff login",
                        keyValue: values.addOns.staffLogin,
                        constName: "STAFFLOGIN",
                        price: values.addOnsInput.staffLogin
                    },
                    {
                        keyName: "email Remainder",
                        keyValue: values.addOns.emailRemainder,
                        constName: "EMAILREMAINDER",
                        price: values.addOnsInput.emailRemainder
                    },
                    {
                        keyName: "rewards",
                        keyValue: values.addOns.rewards,
                        constName: "REWARDS",
                        price: values.addOnsInput.rewards,
                    }

                ],
            }
            // console.log(data, 'ooooooooo')
            setSpinner(true)
            axios.post(updateCurrentplan(), { ...data }, { headers: { Authorization: `Bearer ${adminData?.token}` } }).then((resp) => {
                if (resp.data.code === statusCodes.ok) {
                    toast.success(resp.data.message)
                    setSpinner(false)
                    currentPlan()
                    // setDisabled(!disabled)
                }

                else {
                    setSpinner(false)
                }
            })
                .catch(() => {
                    setSpinner(false)
                    toast.error(commonMessage.networkError)
                })
        }
    })
    const checkMendatoryBranch = () => {
        axios.post(checkMendatory(), { providerId: id }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setMandatory(resp?.data?.data?.mandatory)
            }
            else {
            }
        }).catch(() => { })
    }
    const endDateUpdate = () => {
        if (!editEndDate?.endDate && !editEndDate?.reason) return toast.warn('Please fill the required fields')
            if (!editEndDate?.endDate) return toast.warn('Please select end date')
            if (!editEndDate?.reason) return toast.warn('Please enter reason')
        let payload = {
            userId: id,
            loggedInUserId: adminData.userId,
            endDate: moment(editEndDate?.endDate)?.utc(),
            planId: currentPlanData?._id,
            reason: editEndDate?.reason
        }
        // console.log(payload,'payload')
        // return
        axios.post(updatePlanDate(), payload, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setEditEndDate((pre) => ({ ...pre, open: false, endDate: '', reason: '' }))
                toast.success(resp.data.message)
                currentPlan()
            }
            else {
            }
        }).catch(() => { })
    }
    const getPlanHistory = () => {
        const data = {
            userId: id,
            page: page,
            count: PER_PAGE
        }
        setSpinner(true)
        axios.post(planHistory(), { ...data }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setPlanHistoryData(resp.data)
                setCount(resp.data.totalCount);
                setSpinner(false)

            }
            else {
                setPlanHistoryData([])
                setSpinner(false)
                if (page > 1) {
                    setPage(page - 1)
                }
            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
                setSpinner(false)
            })
    }
    return {
        navigate,
        balance,
        checkRefund,
        cancelPlans,
        setShow,
        setTab,
        setSpinner,
        endDateUpdate,
        setEditEndDate,
        setPlanType,
        getPlanHistory,
        setCount,
        setPage,
        count,
        page,
        PER_PAGE,
        planHistoryData,
        editEndDate,
        planType,
        id,
        adminData,
        spinner,
        countryData,
        teamData,
        serviceData,
        branchData,
        pendingBalance,
        currentPlanData,
        tab,
        assignedPlanData,
        cancelPrice,
        show,
        addOnsUpdate,
        mandatory

    }
}

export default UseAssignPlan